<template>
    <div class="">
        <ctlHomeNav></ctlHomeNav>
        <!-- <v-layout>
            <v-flex xs12 class="text-xs-center">
                <v-btn large @click.prevent="newQuote()" class="secondary" >Start a New Quote</v-btn>
            </v-flex>

        </v-layout> -->
        <v-layout row v-if="error">
            <v-flex xs12>
                <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
            </v-flex>
        </v-layout>     
        <v-container fluid >
            <v-layout align-start>
                <v-flex xs12>
                    <v-card class="elevation-12">
                    <v-toolbar dark color="secondary">
                        <v-spacer></v-spacer>
                        <v-toolbar-title>Find Quote</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <ctlQuoteSearchFilter @onSearchParamsChanged="onSearchParamsChanged"></ctlQuoteSearchFilter>
                    </v-card-text>
                    <v-card-text v-if="quotes.length">
                        <v-layout row wrap class="hidden-sm-and-up">
                            <v-flex v-for="item in quotes" :key="item.id"
                                xs12 sm6 md4 lg3
                            >
                                <v-card >
                                <v-card-title class="text-xs-center accent" :class="jobColor(item.statusId)" height="40">
                                    <v-spacer></v-spacer>
                                    <h4>{{ item.num }} - {{ item.statusId }}</h4>
                                    <v-spacer></v-spacer>
                                </v-card-title>
                                <v-divider></v-divider>
                                <v-card-text row wrap style="padding-bottom: 3px;">
                                    <v-layout>
                                        <v-flex body-2 text-xs-center pb-1 no-wrap text-truncate>{{ item.facilityName }}</v-flex>
                                    </v-layout>
                                    <v-layout>
                                    <v-flex xs4 body-2 pt-1>Quote Date:</v-flex>
                                    <v-flex xs8 text-xs-left pt-1>{{ item.quoteDate }}</v-flex>
                                    </v-layout>

                                    <v-layout>
                                    <v-flex xs4 body-2 pt-1>Total Amt.:</v-flex>
                                    <v-flex xs8 text-xs-left pt-1>
                                        <!-- {{ item.totalAmount | toCurrency }} -->
                                        {{ formatCurrency((!item.totalAmount? 0 : item.totalAmount), item.totalAmountCurrnIdx) }}
                                    </v-flex>
                                    </v-layout>
                                    <v-layout>
                                    <v-flex xs4 body-2 pt-1>Acct. #:</v-flex>
                                    <v-flex xs8 text-xs-left pt-1>{{ item.facilityAcctNo }}</v-flex>
                                    </v-layout>
                                    <!-- <v-layout>
                                    <v-flex xs4 body-2 pt-1>Territory:</v-flex>
                                    <v-flex xs8 text-xs-left pt-1>{{ item.facilityTerritory }}</v-flex>
                                    </v-layout> -->
                                    <v-layout>
                                    <v-flex xs4 body-2 pt-1>Contact:</v-flex>
                                    <v-flex xs8 text-xs-left pt-1>{{ item.contactName }}</v-flex>
                                    </v-layout>
                                    <v-layout>
                                    <v-flex xs4 body-2 pt-1>Phone:</v-flex>
                                    <v-flex xs8 text-xs-left pt-1>{{ item.phone }}</v-flex>
                                    </v-layout>
                                    <!-- <v-layout>
                                    <v-flex xs4 body-2 pt-1>Email:</v-flex>
                                    <v-flex xs8 text-xs-left pt-1>{{ item.email }}</v-flex>
                                    </v-layout> -->
                                    <v-layout>
                                    <v-flex xs4 body-2 pt-1>Sales Rep.:</v-flex>
                                    <v-flex xs8 text-xs-left pt-1>{{ item.salesRep.name }}</v-flex>
                                    </v-layout>
                                    <v-layout>
                                    <v-flex xs4 body-2 pt-1>Cs Rep.:</v-flex>
                                    <v-flex xs8 text-xs-left pt-1>{{ item.csRep.name }}</v-flex>
                                    </v-layout>
                                    <v-layout>
                                    <v-flex xs4 body-2 pt-1>Inside Rep.:</v-flex>
                                    <v-flex xs8 text-xs-left pt-1>{{ item.isRep.name }}</v-flex>
                                    </v-layout>
                                    <!-- <v-layout>
                                    <v-flex xs4 body-2 pt-1>Create By:</v-flex>
                                    <v-flex xs8 text-xs-left pt-1>{{ item.createBy }}</v-flex>
                                    </v-layout> -->
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn small color="primary" @click.prevent="viewQuote(item.id)">View</v-btn>
                                    <v-spacer></v-spacer>
                                </v-card-actions>
                                </v-card>
                            </v-flex>
                        </v-layout>
                        <ctlQuoteListTableView 
                            class="hidden-xs-only"
                            :quotes="quotes"
                            @viewQuote="viewQuote"
                            ></ctlQuoteListTableView>
                        <div class="text-xs-center">
                            <v-pagination
                            v-model="searchCriteria.page"
                            :length="pages"
                            circle
                            ></v-pagination>
                        </div>
                    </v-card-text>
                    <v-card-text v-else>
                        <v-layout row>
                            <v-alert value="true" color="warning" body-2 outline>No Record Found</v-alert>
                        </v-layout>
                    </v-card-text>

                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <!-- {{userData}} -->
    </div>


</template>
<script>
// import _ from 'lodash'
// import jobTypeApi from '@/api/jobTypeApi'
import ctlQuoteSearchFilter from '@/components/ctlQuoteSearchFilter'
import ctlQuoteListTableView from '@/components/ctlQuoteListTableView'
import ctlHomeNav from '@/components/ctlHomeNav'
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
    components: {
        'ctlQuoteSearchFilter': ctlQuoteSearchFilter,
        'ctlQuoteListTableView': ctlQuoteListTableView,
        'ctlHomeNav': ctlHomeNav
        },
    data: () => ({
        searchCriteria: {
            // statusSelected: [1, 5],
            // jobTypeSelected: 0
        },
        pages: null,
        quotes: [],
        showAddNew: true,

    }),
    computed: {
        ...mapGetters('auth',[
            'loggedIn',
            'userData',
            'userHasPublicRole',
            'userHasInternalRole',
            'userHasSalesQuoteManagerRole',
        ]),
        userIsAuthenticated () {
            // return this.$store.getters.userIsAuthenticated
            return this.loggedIn
        },
        // user () {
        //     // return this.$store.getters.user
        //     return this.userData
        // },
        // jobs () {
            //     return this.$store.getters.loadedJobs
        // },
        error () {
            return this.$store.getters.error
        },
        loading () {
            return this.$store.getters.loading
        }
    },
    watch: {
        searchCriteria: {
            handler: async function (newVal, oldVal) {
                console.log(`${newVal.page} === ${oldVal.page}`)
                // if page not changes, it means the search fired from other search filters
                // so I need reset page = 1
                if(oldVal && newVal.page === oldVal.page) {
                    // newVal.page = 1
                }
                await this.searchQuotes()
            },
            deep: true
        },
        userIsAuthenticated (value) {
            if (!value) {
                this.$router.push('/')
            }
        }
    },
    methods: {
        ...mapActions('pubQuoteSearch',[
            'searchQuotesForSalesRep'
        ]),
        ...mapMutations('pubQuoteSearch',[
            'setUserQuoteSearchParams'
        ]),
        async onSearchParamsChanged (paras) {
            this.searchCriteria = Object.assign({}, paras)
            
        },
        async searchQuotes () {
            const searchResult = await this.searchQuotesForSalesRep(this.searchCriteria)
            this.quotes = searchResult.records
            this.pages = searchResult.pageCount
            this.setUserQuoteSearchParams(this.searchCriteria)
        },
        jobColor (jobStatus) {
            if (jobStatus === 'Cancelled') {
                return 'red--text lighten-3'
            }
            if (jobStatus === 'Lost') {
                return 'red--text lighten-3'
            }
            if (jobStatus === 'NeedMoreInfo') {
                return 'orange--text lighten-3'
            }
            if (jobStatus === 'Editing') {
                return 'blue--text lighten-3'
            }
            if (jobStatus === 'Processing' 
                || jobStatus === 'DiscountApproved') {
                return 'blue--text lighten-3'
            }
            if (jobStatus === 'Revising') {
                return 'blue--text lighten-3'
            }
            if (jobStatus === 'Won') {
                return 'green--text lighten-3'
            }
            if (jobStatus === 'SentToCustomer') {
                return 'purple--text lighten-3'
            }
            if (jobStatus === 'WaitingForProcess') {
                return 'blue--text lighten-3'
            }
        },
        viewQuote: function (id) {
            // console.table(job)
            if(this.userHasInternalRole) {
                this.$router.push({ name: 'int-quote-board', params: { id: id } })
            }
            //20200625, add for International Territory Rep
            else if(this.userHasSalesQuoteManagerRole){
                this.$router.push({ name: 'int-quote-board', params: { id: id } })
            }
            else {
                this.$router.push({ name: 'pub-quote-board', params: { id: id } })

            }
        },
        newQuote: function () {
            // console.log('open pub-quote-new')
            this.$router.push({ name: 'pub-quote-new' })
        },
        onDismissed () {
            // console.log('onDismissed alert')
            // this.$store.dispatch('clearError')
        }
    },
    created: async function () {

    },
    mounted: function () {
        // this.searchQuotes()
        console.log('this.userHasInternalRole' + this.userHasInternalRole)
        console.log('this.userHasPublicRole' + this.userHasPublicRole)

    },

    destroyed: function () {
        this.onDismissed()
    }
}
</script>